module.exports = __webpack_public_path__ + "static/images/icon-bg.d287990.png";